import { PostProperties } from "../types";
import image from "../img/lostGemPaulJohnson.jpg";

const post: PostProperties = {
  id: 9,
  title: "Paul Johnson - Zentra, Chicago (03.10.2003)",
  content: "One of the greatest. RIP",
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/pauljohnsonzentrachicago03102003",
  category: "Lost Gem",
  translationsBg: {
    content: "Един от най-великите. RIP",
  },
};

export default post;
